import React from 'react';
import Modal from 'react-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import Logger from '../../../utils/Logger';
import modal from '../../../definitions/Modal';
import OTButton from '../../../components/tag/OTButton';

const { id: module_id } = module;
const logger = Logger(module_id);

const notificationModal = modal({
  content: { padding: '30px 20px', fontSize: '18px' },
});

const EagreementCancelModal = ({ isOpen, closeModal, cancelAgreement }) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={notificationModal}
    >
      <div className="row-fluid eAgreementModal">
        <h4>
          <FormattedMessage
            id={`${module_id}.queryHeading`}
            values={{ br: <br /> }}
          />
        </h4>

        <p>
          <FormattedMessage id={`${module_id}.query`} />
        </p>
      </div>
      <div className="row-fluid eAgreementModalBtn">
        <OTButton className="ot-button--gray" onClick={closeModal}>
          <FormattedMessage id={'back'} />
        </OTButton>
        <OTButton onClick={cancelAgreement}>
          <FormattedMessage id={'yes'} />
        </OTButton>
      </div>
    </Modal>
  );
};

export default injectIntl(EagreementCancelModal);
